import { FormlyFieldConfig } from 'ng-formly';
export const entityfieldformfields: Array<FormlyFieldConfig> = [
    {
        key: 'fieldtype',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Auto Number',
                value: 'autonumber'
                // }, {
                //     label: 'Formula',
                //     value: 'formula'
            }, {
                label: 'Roll-up Summary',
                value: 'rollupsummary'
            }, {
                label: 'Lookup Relationship',
                value: 'lookup'
            }, {
                label: 'External Lookup Relationship',
                value: 'externallookup'
            }, {
                label: 'Sub-Entity',
                value: 'subentity'
            }, {
                label: 'Checkbox',
                value: 'checkbox'
            }, {
                label: 'Currency',
                value: 'currency'
            }, {
                label: 'Date',
                value: 'date'
            }, {
                label: 'Date & Time',
                value: 'dateandtime'
            }, {
                label: 'Time',
                value: 'time'
            }, {
                label: 'Email',
                value: 'email'
            }, {
                label: 'Geolocation',
                value: 'geolocation'
            }, {
                label: 'Number',
                value: 'number'
            }, {
                label: 'Percent',
                value: 'percent'
            }, {
                label: 'Phone',
                value: 'phone'
            }, {
                label: 'Picklist',
                value: 'picklist'
            }, {
                label: 'Text',
                value: 'text'
            }, {
                label: 'Textarea',
                value: 'textarea'
            }, {
                label: 'Textarea(Long)',
                value: 'textarealong'
            }, {
                label: 'Textarea(Richtext)',
                value: 'textarearich'
            }, {
                label: 'Text(Encrypted)',
                value: 'textencrypted'
            }, {
                label: 'URL',
                value: 'url'
            }, {
                label: 'Repeated Section',
                value: 'repeatedsection'
            },{
                label: 'Field Group',
                value: 'fieldgroup'
            }, {
                label: 'Read Only Label',
                value: 'readonlylabel'
            }, {
                label: 'Child Object',
                value: 'childobject'
            }, {
                label: 'User',
                value: 'user'
            }],
            label: 'Field Type',
            required: true,
            placeholder: 'Select Fieldtype'
        }
    },
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.fieldtype',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Field Name (Unique)'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.fieldtype',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-6',
        hideExpression: '!model.fieldtype',
        templateOptions: {
            placeholder: 'Brief Description of the field',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'helptext',
        type: 'textarea-field',
        className: 'col-md-6',
        hideExpression: '!model.fieldtype',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Helptext'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.fieldtype',
        template: '<hr>',
    },
    {
        key: 'defaultvalue',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.fieldtype || model.fieldtype == "checkbox" || model.fieldtype == "fieldgroup"',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Default Value'
        }
    },
    {
        key: 'status',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.fieldtype',
        defaultValue: 'active',
        templateOptions: {
            options: [{
                label: 'Active',
                value: 'active'
            }, {
                label: 'In Active',
                value: 'inactive'
            }],
            label: 'Status',
            required: true,
            placeholder: 'Select Status'
        }
    },
    {
        key: 'sortorder',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.fieldtype',
        defaultValue: 100,
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: true,
            label: 'Sort Order'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "subentity"',
        template: '<hr>',
    },
    {
        key: 'subentitytype',
        type: 'select-component',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "subentity"',
        defaultValue: 'single',
        templateOptions: {
            options: [{
                label: 'Single',
                value: 'single'
            }, {
                label: 'Multi',
                value: 'multi'
            }],
            label: 'Component Type',
            required: false
        }
    },
    {
        key: 'subentity',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "subentity"',
        templateOptions: {
            type: 'entity',
            label: 'Sub Entity',
            options: [],
            required: false,
            placeholder: ''
        }
    },
    {
        key: 'subentityfields',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: 'model.fieldtype !== "subentity"',
        templateOptions: {
            type: 'entityfield',
            label: 'Sub Entity Fields',
            options: [],
            parent: 'subentity',
            multiple: true,
            required: false,
            placeholder: 'Leave blank for All Fields'
        }
    },
    {
        key: 'subentityformtemplate',
        type: 'textarea-field',
        hideExpression: 'model.fieldtype !== "subentity"',
        className: 'col-md-12',
        templateOptions: {
            placeholder: 'Leave blank for Entity Level Template',
            required: false,
            label: 'Sub Entity Form Template (Please Minify the JSON before Pasting here)'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "text"',
        template: '<hr>',
    },
    {
        key: 'displayformat',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "text"',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Display Format'
        }
    },
    {
        key: 'length',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "text"',
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: false,
            label: 'Length'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "date" || model.fieldtype !== "dateandtime" || model.fieldtype !== "time"',
        template: '<hr>',
    },
    {
        key: 'datetimeformat',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "date" || model.fieldtype !== "dateandtime" || model.fieldtype !== "time"',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Date/Time Format'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "autonumber"',
        template: '<hr>',
    },
    {
        key: 'prefix',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "autonumber"',
        defaultValue: '',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Prefix'
        }
    },
    {
        key: 'startingnumber',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "autonumber"',
        defaultValue: '1',
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: false,
            label: 'Starting Number'
        }
    },
    {
        key: 'suffix',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "autonumber"',
        defaultValue: '',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Suffix'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "checkbox"',
        template: '<hr>',
    },
    {
        key: 'checkboxdefault',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "checkbox"',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Checkbox Default Value'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "number"',
        template: '<hr>',
    },
    {
        key: 'decimalplaces',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "number"',
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: false,
            label: 'Decimal Places'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: 'model.fieldtype !== "lookup" && model.fieldtype !== "externallookup"',
        template: '<hr>',
    },
    {
        key: 'lookupcollection',
        type: 'select-component',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "externallookup"',
        defaultValue: 'single',
        templateOptions: {
            options: [{ 'label': 'Account', 'value': 'account' },
            { 'label': 'Activity', 'value': 'activity' },
            { 'label': 'App', 'value': 'app' },
            { 'label': 'Apptype', 'value': 'apptype' },
            { 'label': 'Chart', 'value': 'chart' },
            { 'label': 'Counter', 'value': 'counter' },
            { 'label': 'Country', 'value': 'country' },
            { 'label': 'Currency', 'value': 'currency' },
            { 'label': 'Dashboard', 'value': 'dashboard' },
            { 'label': 'Dataelement', 'value': 'dataelement' },
            { 'label': 'Entity', 'value': 'entity' },
            { 'label': 'Entityfield', 'value': 'entityfield' },
            { 'label': 'Entity Formula', 'value': 'entityformula' },
            { 'label': 'Entitypage Layout', 'value': 'entitypagelayout' },
            { 'label': 'Entityrecord', 'value': 'entityrecord' },
            { 'label': 'Entityrecord History', 'value': 'entityrecordhistory' },
            { 'label': 'Entitysearch Layout', 'value': 'entitysearchlayout' },
            { 'label': 'Installation', 'value': 'installation' },
            { 'label': 'Menuitem', 'value': 'menuitem' },
            { 'label': 'Note', 'value': 'note' },
            { 'label': 'Notification', 'value': 'notification' },
            { 'label': 'Paastenant', 'value': 'paastenant' },
            { 'label': 'Picklist', 'value': 'picklist' },
            { 'label': 'Picktable', 'value': 'picktable' },
            { 'label': 'Reporttemplate', 'value': 'reporttemplate' },
            { 'label': 'Task', 'value': 'task' },
            { 'label': 'Tenant', 'value': 'tenant' },
            { 'label': 'Timezone', 'value': 'timezone' }],
            label: 'Lookup Collection',
            required: false
        }
    },
    {
        key: 'lookupfieldtype',
        type: 'select-component',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "lookup" && model.fieldtype !== "externallookup"',
        defaultValue: 'single',
        templateOptions: {
            options: [{
                label: 'Single',
                value: 'single'
            }, {
                label: 'Multi',
                value: 'multi'
            }],
            label: 'Lookup Field Type',
            required: false
        }
    },
    {
        key: 'lookupfield',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '(model.fieldtype !== "lookup" && model.fieldtype !== "externallookup") || !model.lookupfieldtype',
        templateOptions: {
            type: 'entity',
            label: 'Lookup Entity',
            options: [],
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        key: 'lookupfieldactualname',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '(model.fieldtype !== "lookup" && model.fieldtype !== "externallookup") || !model.lookupfieldtype || !model.lookupfield',
        defaultValue: 'name',
        templateOptions: {
            type: 'entityfield',
            savenames: true,
            parent: 'lookupfield',
            label: 'Actual Name of the Lookup Field',
            options: [],
            required: false,
            placeholder: ''
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.fieldtype',
        template: '<hr>',
    },
    {
        key: 'picklistfieldtype',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "picklist"',
        defaultValue: 'single',
        templateOptions: {
            inline: true,
            options: [{
                label: 'Single',
                value: 'single'
            }, {
                label: 'Multi',
                value: 'multi'
            }, {
                label: 'Radio',
                value: 'radio'
            }],
            label: 'Picklist Field Type',
            required: false
        }
    },
    {
        key: 'picklistvaluetype',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: 'model.fieldtype !== "picklist"',
        defaultValue: 'global',
        templateOptions: {
            options: [{
                label: 'Global',
                value: 'global'
            }, {
                label: 'DataElement',
                value: 'dataelement'
            }, {
                label: 'Custom',
                value: 'custom'
            }],
            label: 'Picklist Type',
            required: false
        }
    },
    {
        key: 'picklistglobalvalues',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: 'model.picklistvaluetype !== "global" || model.fieldtype !== "picklist"',
        templateOptions: {
            type: 'picklist',
            'options': [],
            label: 'Global Picklist',
            required: false,
        }
    },
    {
        key: 'picklistdataelement',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: 'model.picklistvaluetype !== "dataelement" || model.fieldtype !== "picklist"',
        templateOptions: {
            type: 'dataelement',
            'options': [],
            label: 'DataElement',
            required: false,
        }
    },
    {
        type: 'repeatedsection',
        key: 'picklistcustomvalues',
        className: 'col-md-12',
        // hideExpression: 'model.picklistvaluetype != "custom"',
        fieldArray: {
            templateOptions: {
                btnText: 'Add Picklist Custom values',
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'label',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Product Name',
                        required: true,
                    },
                },
                {
                    type: 'input-field',
                    key: 'value',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Value',
                        required: true,
                    },
                }
            ]
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.fieldtype',
        template: '<hr>',
    },
    {
        key: 'required',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Required'
        }
    },
    {
        key: 'isrepeatedchild',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Repeated Section Child'
        }
    },
    {
        key: 'isfieldgroupchild',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype || model.fieldtype =="repeatedsection"',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'FieldGroup Child'
        }
    },
    {
        key: 'cascaded',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "lookup"',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Cascaded Lookup'
        }
    },
    {
        key: 'savenames',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "lookup"',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Save Name as Value'
        }
    },
    {
        key: 'typeahead',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "lookup"',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Enable TypeAhead'
        }
    },
    {
        key: 'detailnavigation',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: 'model.fieldtype !== "lookup"',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Detail Navigation on Select'
        }
    },
    {
        key: 'textlookup',
        type: 'checkbox',
        className: 'col-md-2',
        defaultValue: false,
        hideExpression: '!model.fieldtype',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Data Label Lookup'
        }
    },
    {
        key: 'textpicklist',
        type: 'checkbox',
        className: 'col-md-2',
        defaultValue: false,
        hideExpression: '!model.fieldtype',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Data Label Picklist'
        }
    },
    {
        key: 'lookupdatapull',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Lookup Data Pull'
        }
    },
    {
        key: 'dataelementpull',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'DataElement Pull'
        }
    },
    {
        key: 'validateWithField',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Validate with Field'
        }
    },
    {
        key: 'readonly',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Readonly'
        }
    },
    {
        key: 'unique',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            required: false,
            label: 'Unique'
        }
    },
    {
        key: 'casesensitivity',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            required: false,
            label: 'Case Sensitive'
        }
    },
    {
        key: 'sortalphabetically',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            required: false,
            label: 'Sort Alphabetically'
        }
    },
    {
        key: 'hidden',
        type: 'checkbox',
        className: 'col-md-2',
        hideExpression: '!model.fieldtype',
        defaultValue: false,
        templateOptions: {
            required: false,
            label: 'Hidden Field'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.textpicklist',
        template: '<hr>',
    },
    {
        key: 'textPicklistId',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.textpicklist',
        templateOptions: {
            type: 'picklist',
            label: 'Picklist',
            options: [],
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.textlookup',
        template: '<hr>',
    },
    {
        key: 'textLookupEntity',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.textlookup',
        templateOptions: {
            type: 'entity',
            label: 'Text Lookup Entity',
            options: [],
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        key: 'textLookupField',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.textlookup',
        templateOptions: {
            type: 'entityfield',
            savenames: true,
            parent: 'textLookupEntity',
            label: 'Text Lookup Field',
            options: [],
            required: false,
            placeholder: ''
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.isrepeatedchild || !model.isfieldgroupchild',
        template: '<hr>',
    },
    {
        key: 'parentId',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.isrepeatedchild',
        templateOptions: {
            type: 'entityfield',
            label: 'Parent Field',
            options: [],
            multiple: false,
            required: false,
            repeatedonly: true,
            placeholder: '',
            description: 'Parent Field'
        }
    },
    {
        key: 'parentId',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.isfieldgroupchild',
        templateOptions: {
            type: 'entityfield',
            label: 'Parent Field',
            options: [],
            multiple: false,
            required: false,
            fieldgroup: true,
            placeholder: '',
            description: 'Parent Field'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.cascaded || !model.lookupfield || (model.fieldtype !== "lookup" && model.fieldtype !== "externallookup")',
        template: '<hr>',
    },
    {
        key: 'parentFieldName',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.cascaded || !model.lookupfield || (model.fieldtype !== "lookup" && model.fieldtype !== "externallookup")',
        templateOptions: {
            type: 'entityfield',
            label: 'Parent Field Name',
            options: [],
            savenames: true,
            multiple: false,
            required: false,
            placeholder: '',
            description: 'Parent Field for this field'
        }
    },
    {
        key: 'parentFieldLookupName',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.cascaded || !model.lookupfield || (model.fieldtype !== "lookup" && model.fieldtype !== "externallookup")',
        templateOptions: {
            type: 'entityfield',
            parent: 'lookupfield',
            savenames: true,
            placeholder: '',
            required: false,
            label: 'Matching Field of Lookup Entity',
            description: 'Field Name of the Lookup which is the parent Field for this field'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.lookupdatapull',
        template: '<hr>',
    },
    {
        key: 'parentLookupField',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.lookupdatapull',
        templateOptions: {
            type: 'entityfield',
            label: 'Parent Lookup Field',
            options: [],
            savenames: true,
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        key: 'parentLookupEntity',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.lookupdatapull',
        templateOptions: {
            type: 'entity',
            label: 'Parent Field Lookup Entity',
            options: [],
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        key: 'parentLookupDataField',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.lookupdatapull',
        templateOptions: {
            type: 'entityfield',
            label: 'Data Field from Parent Lookup Record',
            options: [],
            parent: 'parentLookupEntity',
            savenames: true,
            multiple: false,
            required: false,
            placeholder: ''
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.dataelementpull',
        template: '<hr>',
    },
    {
        key: 'dataelementid',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: '!model.dataelementpull',
        templateOptions: {
            type: 'dataelement',
            'options': [],
            label: 'DataElement',
            required: false,
        }
    },
    {
        key: 'dataelementkey',
        type: 'input-field',
        className: 'col-md-4',
        hideExpression: '!model.dataelementpull',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'DataElement Key'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.validateWithField',
        template: '<hr>',
    },
    {
        key: 'validateOperation',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.validateWithField',
        templateOptions: {
            options: [{
                label: 'Equal To',
                value: '=='
            }, {
                label: 'Not Equal To',
                value: '!=='
            }, {
                label: 'Less Than',
                value: '<'
            }, {
                label: 'Less Than or Equal To',
                value: '<='
            }, {
                label: 'Greater Than',
                value: '>'
            }, {
                label: 'Greater Than or Equal To',
                value: '>='
            }],
            label: 'Validate Operation'
        }
    },
    {
        key: 'validateField',
        type: 'select-component',
        className: 'col-md-6',
        hideExpression: '!model.validateWithField',
        templateOptions: {
            type: 'entityfield',
            savenames: true,
            label: 'Validate Field',
            options: [],
            required: false
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.fieldtype',
        template: '<hr>',
    },
    {
        type: 'repeatedsection',
        key: 'picklistdataelementfilters',
        className: 'col-md-12',
        // hideExpression: 'model.picklistvaluetype !== "dataelement"',
        fieldArray: {
            templateOptions: {
                btnText: 'Add DataElement Filter Fields',
            },
            fieldGroup: [
                {
                    key: 'filtername',
                    type: 'input-field',
                    className: 'col-md-3',
                    templateOptions: {
                        type: 'text',
                        placeholder: '',
                        required: true,
                        label: 'Variable to replace'
                    }
                },
                {
                    key: 'filterentity',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'entity',
                        label: 'Choose Current Entity',
                        options: [],
                        multiple: false,
                        required: true,
                        placeholder: ''
                    }
                },
                {
                    key: 'filterfield',
                    type: 'select-component',
                    className: 'col-md-5',
                    hideExpression: '!model.filterentity',
                    templateOptions: {
                        type: 'entityfield',
                        savenames: true,
                        parent: 'filterentity',
                        label: 'Filter Field',
                        options: [],
                        required: true,
                        placeholder: ''
                    }
                }
            ]
        }
    },
    {
        key: 'hideexpression',
        hideExpression: '!model.fieldtype',
        className: 'col-md-6',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Hide Expression Code'
        }
    },
    {
        key: 'expressionproperties',
        hideExpression: '!model.fieldtype',
        className: 'col-md-6',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Expression Properties Code'
        }
    },
    {
        key: 'lifecycle',
        hideExpression: '!model.fieldtype',
        className: 'col-md-6',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Lifecyle Event Code'
        }
    },
    {
        key: 'validationpattern',
        hideExpression: '!model.fieldtype',
        className: 'col-md-6',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Validation Pattern / Regex'
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/entityfield.ts